import {
  SET_CUSTOMER_TYPES,
  SET_SUPPLIERS,
  SET_DISTRIBUTORS,
  SET_DISTRIBUTOR,
  SET_CUSTOMER_TYPE,
  SET_METER_TYPE,
  SET_POWER_MEASUREMENT,
  SET_CONSUMPTION_TYPE,
  SET_REACTIVE_ENERGY_TYPE,
} from '../mutationTypes';

const moduleFilter = {
  namespaced: true,

  state: {
    customerTypes: [],
    distributors: [],
    suppliers: [],
    reactiveEnergyType: 'without',
    activeFilters: {
      distributor: 18,
      customerType: 1,
      powerMeasurement: 'with',
      meterType: 'double_rate_meter',
      consumtionType: true,
    },
  },

  getters: {
    singleRate: state => state.activeFilters.meterType === 'single_rate_meter',
    // withoutPowerMeasurement: state => state.activeFilters.powerMeasurement === 'without',
  },

  actions: {

  },

  mutations: {
    [SET_CUSTOMER_TYPES](state, payload) {
      state.customerTypes = payload;
    },
    [SET_DISTRIBUTORS](state, payload) {
      state.distributors = payload;
    },
    [SET_SUPPLIERS](state, payload) {
      state.suppliers = payload;
    },
    [SET_DISTRIBUTOR](state, payload) {
      state.activeFilters.distributor = payload;
    },
    [SET_CUSTOMER_TYPE](state, payload) {
      state.activeFilters.customerType = payload;
    },
    [SET_POWER_MEASUREMENT](state, payload) {
      state.activeFilters.powerMeasurement = payload;
    },
    [SET_CONSUMPTION_TYPE](state, payload) {
      state.activeFilters.consumtionType = payload;
    },
    [SET_METER_TYPE](state, payload) {
      state.activeFilters.meterType = payload;
    },
    [SET_REACTIVE_ENERGY_TYPE](state, payload) {
      state.reactiveEnergyType = payload;
    },
  },
};

export default moduleFilter;
